import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import { images } from '../data/mockData';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-lg' : 'bg-white/80 backdrop-blur-sm'
    }`}>
      <div className="container mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          <button 
            onClick={() => scrollToSection('home')}
            className="hover:opacity-80 transition-opacity"
          >
            <img 
              src={images.logo} 
              alt="VM Projekty & Stavby" 
              className="h-20 w-auto object-contain logo-image"
            />
          </button>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <button onClick={() => scrollToSection('home')} className="nav-link">
              Domů
            </button>
            <button onClick={() => scrollToSection('services')} className="nav-link">
              Služby
            </button>
            <button onClick={() => scrollToSection('why-us')} className="nav-link">
              Proč my
            </button>
            <button onClick={() => scrollToSection('references')} className="nav-link">
              Reference
            </button>
            <Button 
              onClick={() => scrollToSection('contact')}
              className="btn-primary"
            >
              Kontakt
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-brand-primary p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <nav className="md:hidden py-6 space-y-4 border-t border-border-medium">
            <button 
              onClick={() => scrollToSection('home')} 
              className="block w-full text-left nav-link"
            >
              Domů
            </button>
            <button 
              onClick={() => scrollToSection('services')} 
              className="block w-full text-left nav-link"
            >
              Služby
            </button>
            <button 
              onClick={() => scrollToSection('why-us')} 
              className="block w-full text-left nav-link"
            >
              Proč my
            </button>
            <button 
              onClick={() => scrollToSection('references')} 
              className="block w-full text-left nav-link"
            >
              Reference
            </button>
            <Button 
              onClick={() => scrollToSection('contact')}
              className="btn-primary w-full"
            >
              Kontakt
            </Button>
          </nav>
        )}
      </div>
    </header>
  );
};
